import { useParams } from "@tanstack/react-router";
import PosteForm from "@features/creation/postes/components/PosteForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import { usePosteDetail } from "@features/creation/postes/hooks/usePostes";

export const Route = createFileRoute("/_app/creation/postes/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.POSTES.EDIT),
  staticData: {
    title: "Modifier le poste",
    icon: Pencil,
    permission: PERMISSIONS.CREATION.POSTES.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditPostePage,
});

function EditPostePage() {
  const { id } = useParams({ from: "/_app/creation/postes/$id/edit" });
  const { data: poste, isLoading } = usePosteDetail(id);

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Modifier le poste</h1>
        </div>
        <div className="space-y-4">
          <div className="skeleton h-12 w-full" />
          <div className="skeleton h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier le poste</h1>
        <p className="text-sm text-base-content/60">
          Modifier les informations du poste {poste?.code}
        </p>
      </div>
      <PosteForm poste={poste} />
    </div>
  );
}
